import { SVGProps } from "react";

const Malaysia = (props: SVGProps<SVGSVGElement>) => {
  const { width = 24, height = 24 } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_175_42147"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="20"
        height="20"
      >
        <path
          d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_175_42147)">
        <path
          d="M27 2H4.5C3.11929 2 2 3.11929 2 4.5V19.5C2 20.8807 3.11929 22 4.5 22H27C28.3807 22 29.5 20.8807 29.5 19.5V4.5C29.5 3.11929 28.3807 2 27 2Z"
          fill="white"
        />
        <path d="M29.5 2H2V3.4359H29.5V2Z" fill="#AF010D" />
        <path d="M29.5 4.87207H2V6.30797H29.5V4.87207Z" fill="#AF010D" />
        <path d="M29.5 7.74365H2V9.17955H29.5V7.74365Z" fill="#AF010D" />
        <path d="M29.5 10.6155H2V12.0514H29.5V10.6155Z" fill="#AF010D" />
        <path d="M29.5 13.4871H2V14.923H29.5V13.4871Z" fill="#AF010D" />
        <path d="M29.5 16.3589H2V17.7948H29.5V16.3589Z" fill="#AF010D" />
        <path d="M29.5 19.231H2V20.6669H29.5V19.231Z" fill="#AF010D" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 2H16.4047V13.4933H2V2Z"
          fill="#1A47B8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.1666 7.33325H12.4761V8.66659H11.1666V7.33325Z"
          fill="#FFDA2C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.8214 10.0001C11.2242 10.8094 10.2735 11.3334 9.20234 11.3334C7.39519 11.3334 5.92853 9.84008 5.92853 8.00008C5.92853 6.16008 7.39519 4.66675 9.20234 4.66675C10.2735 4.66675 11.2242 5.19075 11.8214 6.00008H9.85709C8.77281 6.00008 7.89281 6.89608 7.89281 8.00008C7.89281 9.10408 8.77281 10.0001 9.85709 10.0001H11.8214Z"
          fill="#FFDA2C"
        />
      </g>
    </svg>
  );
};

export default Malaysia;
